import * as uuid from 'uuid';
import { ITaskReminder } from 'services/TaskManagementApi/types/TaskManagementResponse';

export const UUIDV5_NAMESPACE = '27ba6479-1910-4f20-b2cd-424c58c49e5a';

export const generateStableReminderUuid = (reminder: ITaskReminder) => {
    return uuid.v5(`${reminder.channel}-${reminder.offset}-${reminder.offsetUnit}`, UUIDV5_NAMESPACE);
}

/**
 * TMS refuses a task the user may not see with a 403 / ACCESS_DENIED on the task, comments and
 * uploads endpoints. The page carries the message itself, so callers suppress their generic toast.
 */
export const isAccessDeniedError = (e: any): boolean => {
    const errors: { message: string; errorCode: string }[] = e?.response?.data?.errors ?? [];
    return e?.response?.status === 403 || errors.some(error => error.errorCode === 'ACCESS_DENIED');
}

/** TMS error codes shared by the create / edit task endpoints, as toast messages. */
export const TASK_ERROR_MESSAGES: Record<string, string> = {
    BOOKING_NOT_FOUND: 'Booking Ref. is invalid',
    CATEGORY_NOT_FOUND: 'Category is invalid',
    TEAM_NOT_FOUND: 'Team is invalid',
    USER_NOT_FOUND: 'User is invalid',
    ACCESS_DENIED: 'Access denied',
    REVIEWER_REQUIRED: 'A reviewer is required for the To Review status',
};

/** TMS error codes of the recurring task endpoints, as toast messages. */
export const RECURRING_TASK_ERROR_MESSAGES: Record<string, string> = {
    // TMS_RECURRING_TASKS_TEMP is off
    NOT_FOUND: 'Recurring tasks are not available',
    // OWA-11997 update / OWA-11998 delete: deleted meanwhile, or restricted away from the user
    TASK_NOT_FOUND: 'Recurring task not found',
};

/** Toast messages for a failed recurring task call, one per known error code; empty when none is known. */
export const getRecurringTaskErrorMessages = (e: any): string[] => {
    const errors: { message: string; errorCode: string }[] = e?.response?.data?.errors ?? [];
    return errors
        .map(error => RECURRING_TASK_ERROR_MESSAGES[error.errorCode] ?? TASK_ERROR_MESSAGES[error.errorCode])
        .filter(Boolean);
}
